const weekdays = [{
    value: 1,
    label: 'Monday'
  }, {
    value: 2,
    label: 'Tuesday'
  }, {
    value: 3,
    label: 'Wednesday'
  }, {
    value: 4,
    label: 'Thursday'
  }, {
    value: 5,
    label: 'Friday'
  }, {
    value: 6,
    label: 'Saturday'
  }, {
    value: 0,
    label: 'Sunday'
  }]

const getDayFromTimestamp = (timestamp) => {
    const shortMonthsNL = [
      'jan.',
      'feb.',
      'mar.',
      'apr.',
      'may.',
      'jun.',
      'jul.',
      'aug.',
      'sep.',
      'oct.',
      'nov.',
      'dec.'
  ];
  const date = new Date(timestamp);
  return `${date.getDate()} ${shortMonthsNL[date.getMonth()]} ${date.getFullYear()}`;
}

module.exports = {
    weekdays,
    getDayFromTimestamp
}


// WEBPACK FOOTER //
// ./src/assets/js/helpers.js